var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdb-collapse',{attrs:{"toggleTag":['a'],"togglers":1,"toggleClass":['toggler mb-3'],"toggleText":[_vm.question]}},[_c('p',{staticClass:"mt-2 faq--answer",domProps:{"innerHTML":_vm._s(_vm.answer)}})])}
var staticRenderFns = []

export { render, staticRenderFns }